import {
  GET_CUSTOMER_REQUEST,
  LOGIN_REQUEST,
  FB_LOGIN_OR_CREATE_REQUEST,
  GOOGLE_LOGIN_OR_CREATE_REQUEST,
  LOGOUT_REQUEST,
  FORGOT_PASSWORD_REQUEST,
  MAGIC_LINK_REQUEST,
  MAGIC_LINK_ID_REQUEST,
  ACCOUNT_ACTIVATION_ID_REQUEST,
  ADD_CUSTOMER_REQUEST,
  EDIT_CUSTOMER_REQUEST,
  EDIT_PASSWORD_REQUEST,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_ID_REQUEST,
  UNSUBSCRIBE_CUSTOMER_REQUEST,
  DELETE_CUSTOMER_REQUEST
} from './constants';

export const unsubscribe = (customerId, payload, onSuccess) => ({
  type: UNSUBSCRIBE_CUSTOMER_REQUEST,
  customerId,
  payload,
  onSuccess
});

export const getCustomer = () => ({ type: GET_CUSTOMER_REQUEST });

export const createAccount = (customer, onSuccess, onError) => ({
  type: ADD_CUSTOMER_REQUEST,
  customer,
  onSuccess,
  onError
});

export const editCustomer = (params, onSuccess, onError) => ({
  type: EDIT_CUSTOMER_REQUEST,
  params,
  onSuccess,
  onError
});

export const editPassword = (params, onSuccess, onError) => ({
  type: EDIT_PASSWORD_REQUEST,
  params,
  onSuccess,
  onError
});

export const login = (email, password, onSuccess, onError) => ({
  type: LOGIN_REQUEST,
  email,
  password,
  onSuccess,
  onError
});

export const fbLoginOrCreate = (accessToken, onSuccess, onError) => ({
  type: FB_LOGIN_OR_CREATE_REQUEST,
  accessToken,
  onSuccess,
  onError
});

export const googleLoginOrCreate = (tokenId, onSuccess, onError) => ({
  type: GOOGLE_LOGIN_OR_CREATE_REQUEST,
  tokenId,
  onSuccess,
  onError
});

export const forgotPassword = (data, onSuccess, onError) => ({
  type: FORGOT_PASSWORD_REQUEST,
  data,
  onSuccess,
  onError
});

export const resetPassword = (data, onSuccess, onError) => ({
  type: RESET_PASSWORD_REQUEST,
  data,
  onSuccess,
  onError
});

export const magicLink = (data, onSuccess, onError) => ({
  type: MAGIC_LINK_REQUEST,
  data,
  onSuccess,
  onError
});

export const validateResetPasswordId = (resetPasswordId, emailId, onError) => ({
  type: RESET_PASSWORD_ID_REQUEST,
  onError,
  resetPasswordId,
  emailId
});

export const validateMagicLinkId = (magicLinkId, onSuccess, onError) => ({
  type: MAGIC_LINK_ID_REQUEST,
  magicLinkId,
  onError,
  onSuccess
});

export const validateAccountActivationId = (
  accountActivationId,
  onSuccess,
  onError
) => ({
  type: ACCOUNT_ACTIVATION_ID_REQUEST,
  accountActivationId,
  onError,
  onSuccess
});

export const logout = () => ({
  type: LOGOUT_REQUEST
});

export const deleteCustomer = (onSuccess, onError) => ({
  type: DELETE_CUSTOMER_REQUEST,
  onSuccess,
  onError
});
